import StickyViewportFillerHeight from '~/diffs/components/sticky_viewport_filler_height.vue';
import { glSlotsMixin } from '~/lib/utils/vue3compat/gl_slots_mixin';
export default {
    name: 'FileBrowserHeight',
    components: {
        StickyViewportFillerHeight
    },
    mixins: [
        glSlotsMixin
    ],
    props: {
        enableStickyHeight: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data () {
        return {
            minHeight: 0,
            bottomPadding: 0,
            stickyTopOffset: 0
        };
    },
    mounted () {
        const styles = getComputedStyle(this.$el);
        this.stickyTopOffset = parseInt(styles.getPropertyValue('top'), 10);
        this.minHeight = parseInt(styles.getPropertyValue('--file-tree-min-height'), 10);
        this.bottomPadding = parseInt(styles.getPropertyValue('--file-tree-bottom-padding'), 10);
    }
};
